import * as ActionTypes from 'state/actions/types'

export const messagesChangeField = (field, value) => {
  return {
    type: ActionTypes.MESSAGES_CHANGE_FIELD,
    field,
    value
  }
}

export const messagesChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.MESSAGES_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const messagesMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.MESSAGES_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
